import { createClient } from '@sanity/client'
import { apiVersion } from '../env'
import { getSanityConfig } from '../env-config'

const sanityConfig = getSanityConfig()

export const client = createClient({
    projectId: process.env.SANITY_STUDIO_PROJECT_ID,
    dataset: process.env.SANITY_STUDIO_DATASET,
    useCdn: false, // Always false per project requirement
    apiVersion,
    ...sanityConfig, // Spreads token and perspective based on environment
})